import usePersonalizedThemeByCompany from "src/hooks/usePersonalizedThemeByCompany"

export default function ClockPlayer() {
const {styledTheme} = usePersonalizedThemeByCompany()
return (
<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={styledTheme.colors.primary} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>)
}
